export enum QueryParams {
  FILTER_ITEMS = 'f',
  PAGE = 'p',
  SHOW_I18N_KEYS = 'showI18nKeys',
}
